import { type InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import {
  useApi,
  type Issues200Response,
  type IssueSortingDtoOptions,
  type IssueFilteringDtoOptions,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

export type ListIssuesQueryParameters = {
  sort?: IssueSortingDtoOptions;
  filter?: IssueFilteringDtoOptions;
  page?: number;
  limit?: number;
};

export type UseInfiniteIssuesParams = {
  enabled?: boolean;
} & ListIssuesQueryParameters;

export function useInfiniteIssues(props: UseInfiniteIssuesParams) {
  const {
    page = 0,
    limit = 10,
    sort = {},
    filter = {},
    enabled = true,
  } = props;

  const api = useApi();

  const queryKey = ['issues', sort, filter, page, limit, enabled];

  return useInfiniteQuery<
    Issues200Response,
    ExtendedAxiosError,
    InfiniteData<Issues200Response>,
    typeof queryKey,
    number
  >({
    queryKey: ['issues', sort, filter, page, limit, enabled],
    queryFn: ({ pageParam }) =>
      api.issuesApi.issues(sort, filter, pageParam, limit).then((r) => r.data),
    enabled,
    initialPageParam: page,
    getNextPageParam: (lastPage) =>
      lastPage.meta.hasNextPage ? lastPage.meta.page + 1 : undefined,
  });
}
